import { render, staticRenderFns } from "./CreateKKontoDialog.vue?vue&type=template&id=04e28d4b&scoped=true"
import script from "./CreateKKontoDialog.vue?vue&type=script&lang=js"
export * from "./CreateKKontoDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateKKontoDialog.vue?vue&type=style&index=0&id=04e28d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e28d4b",
  null
  
)

export default component.exports